<template>
    <div class="row m-0">
        <div class="col-sm-2 p-0">
            <Sidebar
                :collapsed="sidebarCollapsed"
                :selectedCategory="selectedCategory"
                :mobileView="mobileView"
                :mini="mini"
                :categories="categories"
                @toggle="toggleSidebar"
                @navigate="navigate" />
        </div>

        <div class="col-12 col-sm-10 p-0">
            <div class="row m-0" style="height: calc(100vh - 80px) !important;">
                <div class="col-12">

                    <!-- <Transition name="fade" mode="out-in"> -->
                        <Loading v-if="loading" />
                        <!-- <div v-else :style="!mobileView ? 'margin-left: 350px;' : ''"> -->
                        <div v-else class="row mt-1">
                            <div class="row mt-1">
                                <div class="col-sm-6 offset-sm-3">
                                    <div class="row">
                                        <div class="col-auto">
                                            <button @click="toggleSidebar" class="btn sidebar-toggle d-lg-none">
                                                <i class="fas fa-bars"></i>
                                            </button>
                                        </div>
                                        <div class="col search_input_frm">
                                            <div class="input-group">
                                                <!-- <div v-if="search_text.length" class="ic-icons ic-icon-right" @click="search_text = ''">
                                                    <div class="ic-icon-arrow"></div>
                                                    <i class="fas fa-times ic-btn-clear"></i>
                                                </div> -->
                                                <input v-model="search_text" type="text" class="form-control search_input" :placeholder="TR.code + ' ' + TR.input" :aria-label="TR.code + ' ' + TR.input" aria-describedby="button-addon2" @keyup="searchCallback" icon="" />
                                                <button class="btn search_btn text-light" type="button" id="button-addon2" @click="searchCallback">
                                                    <i class="fas fa-search me-2"></i>
                                                    {{ TR.search }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="products.length">
                                <CarouselMain v-if="selectedProduct != null" :data="selectedProduct" :item_index="selectedProduct.product_images.length && selectedProduct.product_images[0].id" :key="componentKey" />

                                <Carousel
                                    v-if="products.length"
                                    :value="products"
                                    :numScroll="1"
                                    :responsiveOptions="responsiveOptions"
                                    :circular="false"
                                    :autoplayInterval="0"
                                    :showIndicators="products.length > 1 ? true : false"
                                    :showNavigators="(mobileView && products.length > 2) || products.length > 10 ? true : false"
                                    :contentClass="products.length < 3 ? 'align-items-center' : ''"
                                    >
                                    <template #item="slotProps">
                                        <div class="border-11 surface-border1 border-round1 m-2 p-21" :class="slotProps.data.id == selectedProduct.id ? 'active-item' : ''">
                                            <ThumbCard :data="slotProps.data" @navigate="viewProduct" />
                                        </div>
                                    </template>
                                </Carousel>

                                <!-- <div class="row row-cols-2 row-cols-sm-6 g-3">
                                    <div v-for="(item, index) in products" :key="index" class="col">
                                        <ThumbCard :data="item" @navigate="viewProduct" />
                                    </div>
                                </div> -->
                            </div>
                            <div v-else class="notfound-info">
                                <div class="h-100 d-flex flex-column justify-content-center align-items-center fs-4 text-danger fw-bold">
                                    <h1 class="font-display display-3 fw-bold mb-3 text-glow">
                                        <img src="/assets/images/logo_red.png" style="height: 80px;" />
                                    </h1>
                                    {{ TR.noresult }}!
                                </div>
                            </div>
                        </div>
                    <!-- </Transition> -->

                </div>
            </div>
            <div class="row m-0">
                <div class="col-12 p-0">
                    <!-- :lang="{'page': 'Sehife', 'first': 'ilk', 'rows': ''}" -->
                    <Pagination
                        v-if="products.length"
                        :row_count="totalrecords"
                        :pages_count="pages_count"
                        :perpage="perpage"
                        :current_page="current_page"
                        @navigate="pagenav"
                        class="pagenav mt-2"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, watchEffect } from 'vue';

import { useStore } from '@/system_modules/store';

import Carousel from 'primevue/carousel';

import Loading from '@/pages/components/Loading';
import CarouselMain from '@/pages/components/Carousel';
import Sidebar from '@/pages/components/Sidebar';
import ThumbCard from '@/pages/components/ThumbCard';
import Pagination from '@/pages/components/Pagination';

import { G, ajax } from '@/_common';


export default {
    name: 'HomeP',
    title: 'Ana səhifə',
    components: {
        Loading,
        Sidebar,
        CarouselMain,
        Carousel,
        ThumbCard,
        Pagination,
    },
    props:{
        data: {
            type: Object,
            default: () => {}
        },
    },
    setup() {
        const store = useStore();

        const TR = ref({});

        const categories = ref([]);
        const products = ref([]);
        const pages_count = ref(0);

        const componentKey = ref(0);
        const selectedCategory = ref(null);
        const selectedProduct = ref(null);
        const search_text = ref('');

        const loading = ref(true);
        const mobileView = ref(false);
        const mini = ref(false);
        const responsiveOptions = [
            {
                breakpoint: '4000px',
                numVisible: 14,
                numScroll: 1
            },
            {
                breakpoint: '1920px',
                numVisible: 10,
                numScroll: 1
            },
            {
                breakpoint: '1380px',
                numVisible: 6,
                numScroll: 1
            },
            {
                breakpoint: '800px',
                numVisible: 4,
                numScroll: 1
            },
            {
                breakpoint: '575px',
                numVisible: 2,
                numScroll: 1
            }
        ];
        const current_page = ref(null);
        const perpage = ref(10);
        const totalrecords = ref(0);

        // const currentSection = ref('dashboard');
        const sidebarCollapsed = ref(false);
        const toggleSidebar = () => {
            sidebarCollapsed.value = !sidebarCollapsed.value;
        };
        const navigate = async (categoryId) => {
            // currentSection.value = categoryId;
            selectedCategory.value = categoryId;
            // toggleSidebar();
            sidebarCollapsed.value = false;
            // loadProducts();
            current_page.value = 1;
            await getProducts(categoryId);
        };

        const viewProduct = (product_id) => {
            selectedProduct.value = products.value.filter(p => p.id == product_id)[0];
            componentKey.value += 1;
        };

        // const loadProducts = async () => {
        //     loading.value = true;
        //     await new Promise(resolve => setTimeout(resolve, 1000));
        //     selectedCategory.value = categories.value[0].id;
        //     loading.value = false;
        //     // await nextTick();
        //     // setTimeout(animateStats, 500);
        // };

        watchEffect(() => {
            TR.value = store.getTranslation();

            mobileView.value = G.is_mobile();
            // sidebarCollapsed.value = mobileView.value ? true: false;
            mini.value = mobileView.value ? true : false;
        });

        const f = (data, item) => {
            data.forEach(ci => {
                if( ci.id == item.parent ){
                    ci.children.push({
                        "id": item.id,
                        "rank": item.rank,
                        "image": item.image,
                        "name": item.translate && item.translate.length > 0 ? item.translate[0].name : '',
                        "description": item.translate && item.translate.length > 0 ? item.translate[0].description : '',
                        "products": item.products?.length,
                        // "link_param": {category_id: item.id},
                        "children": []
                    });
                }
                else if( ci.children && ci.children.length > 0 ){
                    f(ci.children, item);
                }
            });
        };

        const getProducts = async (catID, first) => {
            search_text.value = "";
            if( first === undefined ) first = 1;
            loading.value = true;
            await ajax({
                url: store.getProductsByCategory(catID) + `?rows=${perpage.value}&first=${(first-1)*perpage.value}`,
				success: (e) => {
                    products.value = e.data.data;
                    totalrecords.value = e.data.total_records;
                    pages_count.value = Math.ceil(e.data.total_records / perpage.value);
                    selectedProduct.value = products.value[0];
                    // document.querySelector('.p-carousel-item-list').setAttribute('style', 'transform: translate3d(0%, 0px, 0px);');
				}
			});
            loading.value = false;
        };

        const getProductsList = async (first) => {
            if( first === undefined ) first = 1;
            loading.value = true;
            selectedCategory.value = 0;
            await ajax({
                url: store.getProductsList() + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
				success: (e) => {
                    products.value = e.data.data;
                    totalrecords.value = e.data.total_records;
                    pages_count.value = Math.ceil(e.data.total_records / perpage.value);
                    selectedProduct.value = products.value[0];
                    // document.querySelector('.p-carousel-item-list').setAttribute('style', 'transform: translate3d(0%, 0px, 0px);');
				}
			});
            loading.value = false;
        };

        onMounted(async() => {
			await ajax({
                url: store.getCategoriesWithChildren(),
                success: (e) => {
                    let res = e.data;
                    let data = [];
                    res.filter(a => a.parent == 0).forEach(item => {
                        data.push({
                            "id": item.id,
                            "rank": item.rank,
                            "image": item.image,
                            "name": item.translate && item.translate.length > 0 ? item.translate[0].name : '',
                            "description": item.translate && item.translate.length > 0 ? item.translate[0].description : '',
                            "products": item.products?.length,
                            // "link_param": {category_id: item.id},
                            "children": []
                        });
                    });
                    res.filter(a => a.parent != 0).forEach(item => {
                        f(data, item);
                    });

                    categories.value = data;
                    selectedCategory.value = data[0].id;
                }
            });

            // getProducts(selectedCategory.value || categories.value[0].id);
            getProducts(selectedCategory.value);
		});

        const pagenav = async (p, pp) => {
            current_page.value = p;
            perpage.value = pp;
            if( search_text.value != '' )
                await getProductsList(p);
            else
                await getProducts(selectedCategory.value, p);
        }

        const searchCallback = (event) => {
            if( event.which == 13 || event.which == 1 ){
                current_page.value = 1;
                getProductsList(1);
            }
        };

        return {
            G,
            TR,
            categories,
			products,
            pages_count,
            totalrecords,
            loading,
            componentKey,
            selectedCategory,
            selectedProduct,
            viewProduct,
            search_text,
            searchCallback,

            // currentSection,
            sidebarCollapsed,
            toggleSidebar,
            navigate,
            mobileView,
            mini,
            responsiveOptions,
            pagenav,
            current_page,
            perpage,
		};
    },
}
</script>


<style lang="scss">
:root {
    --primary-color: rgb(236, 5, 5);
    --primary-dark: rgb(200, 4, 4);
    --primary-light: rgba(236, 5, 5, 0.1);
    --primary-glow: rgba(236, 5, 5, 0.3);
    --bs-primary: var(--primary-color);
    --bs-primary-rgb: 236, 5, 5;
    --sidebar-width: 300px;
    // --background-pagination-gradient: linear-gradient( 135deg, rgba(182, 41, 41, 0.342) 70%, rgba(0, 0, 0, 0.521) 100% );
    --background-pagination-gradient: linear-gradient( 135deg, rgba(206, 16, 16, 0.897) 70%, rgba(70, 6, 6, 0.521) 100% );
    --background-sidebar-gradient: linear-gradient( 135deg, rgba(206, 16, 16, 0.897) 70%, rgba(70, 6, 6, 0.521) 100% );

    // --background-gradient: linear-gradient( 135deg, rgba(150, 147, 147, 0.37) 0%, rgba(168, 46, 46, 0.247) 40%, rgba(182, 41, 41, 0.342) 70%, rgba(0, 0, 0, 0.521) 100% );
    // --background-gradient: linear-gradient( 135deg, rgba(110, 109, 109, 0.7) 0%, rgba(116, 109, 109, 0.4) 40%, rgba(236, 5, 5, 0.3) 70%, rgba(189, 17, 17, 0.377) 100% );
    // --background-gradient: linear-gradient( 135deg, rgba(199, 196, 196, 0.164) 0%, rgba(150, 143, 143, 0.367) 100% );
    // --background-gradient: linear-gradient( 135deg, rgba(0, 0, 0, 0.2) 0%, rgba(32, 28, 28, 0.3) 90%, rgba(0, 0, 0, 0.8) 100% );

    --background-gradient: linear-gradient( 135deg, rgba(150, 147, 147, 0.1) 0%, rgba(168, 46, 46, 0.1) 20%, rgba(182, 41, 41, 0.1) 40%, rgba(0, 0, 0, 0.1) 100% );
}
.p-carousel{
    background-color: transparent !important;
}
.p-carousel-prev-button, .p-carousel-next-button{
    background-color: rgba(var(--bs-primary-rgb), .8) !important;
    padding: 5px 10px !important;
}
.p-icon{
    color: #ffffff;
}
.active-item{
    // border: 3px solid rgba(var(--bs-primary-rgb), .5);
    border-radius: 10px;
    box-shadow:
        0px 0px 0px 5px rgba(228, 25, 25, 0.5),
        0 0 0 1px rgba(211, 27, 27, 0.5);
}
.pagenav{
    background: var(--background-gradient);
    border-radius: 10px;
}
.notfound-info{
    height: calc(100vh - 80px);
}

.search_input_frm{
    display: flex;
    position: relative;
    flex-basis: 0;
    flex-grow: 1;
    -ms-flex-preferred-size: 0;
    -ms-flex-positive: 1;
    max-width: 100%;
}
.search_input{
    border: 1px solid var(--bs-gray-400);
    width: 100%;
    // min-width: 200px;
    border-radius: 20px;
    height: 45px;
    padding: 0 10px;
    background: #ffffff;
    // background: transparent;
    color: #8d979e;
    font-weight: 400;
    font-size: .9rem;
    line-height: 16px;
}
.search_btn{
    position: static;
    min-width: 100px;
    height: 45px;
    border: none;
    cursor: pointer;
    font-weight: 400;
    font-size: .9rem;
    line-height: 1rem;
    border-radius: 20px;
    // background-color: #ff0000;
    background: var(--background-sidebar-gradient);
    text-transform: capitalize;
}


.ic-icons {
    position: absolute;
    top: 50%;
    margin-top: -0.5rem;
    display: flex !important;
    flex-direction: row !important;
    color: #919191;
    z-index: 10;
}
.ic-icon-right {
    right: 0.5rem;
    // margin-right: 10px;
}
.ic-icon-arrow {
    width: 0;
    height: 0;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-right: 6px solid #919191;
}
.ic-btn-clear {
    background: #919191;
    /* color: #919191; */
    color: #ffffff;
    padding: 2px 4px;
    margin-right: 100px;
    font-size: 0.6rem !important;
    font-weight: 900;
    text-align: end;
    /* border: 1px solid #919191; */
    cursor: pointer;
}

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
}
.input-group > button {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+2), .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control, .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select, .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating) {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
}


@media(max-width: 578px){
    .notfound-info{
        height: calc(100vh - 110px);
    }
}
</style>
